import type React from 'react';
import { createContext, useContext } from 'react';

// Set inside a periodic review, whose steps reuse onboarding's but work on drafts until the customer confirms it
const PeriodicReviewContext = createContext(false);

export const PeriodicReviewProvider = ({ children }: React.PropsWithChildren) => {
  return <PeriodicReviewContext.Provider value>{children}</PeriodicReviewContext.Provider>;
};
PeriodicReviewProvider.displayName = 'PeriodicReviewProvider';

export const useIsPeriodicReview = () => useContext(PeriodicReviewContext);
